import { useEffect, useLayoutEffect, useState } from "react";
import { FixFooterPosition } from "../Helpers/helper";

export type useWindowSizeResultType = {
    Width: number,
    Height: number
}

export const useWindowSize = (): useWindowSizeResultType => {
    const [size, setSize] = useState<useWindowSizeResultType>({ Width: 0, Height: 0 });
    useLayoutEffect(() => {
        function updateSize() {
            setSize({ Width: window.innerWidth, Height: window.innerHeight });
        }
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
}

export const useRecalculateFooter = (): void => {
    const { Width, Height } = useWindowSize();

    useEffect(() => {
        FixFooterPosition()
    }, [Width, Height])
}